import React, { useEffect, useState } from 'react'
import IconButton from '@mui/material/IconButton'
import AddIcon from '@mui/icons-material/Add'
import RemoveIcon from '@mui/icons-material/Remove'
import { MAX_PRODUCT_QTY } from '../../../../constants'

interface Props {
  quantity?: number
  availableQuantity: number
  cartQuantity: number
  onChangeQuantity: (val: number) => void
  canZero: boolean
}

const QuantityInputField: React.FC<Props> = ({
  quantity = 1,
  onChangeQuantity,
  availableQuantity,
  canZero = false,
}) => {
  const [localQty, setLocalQty] = useState<string>(quantity.toString())

  useEffect(() => {
    setLocalQty(quantity.toString())
  }, [quantity])

  const min = canZero ? 1 : 2

  const handleChangeQty = (qty: string) => {
    if (qty !== '' && +qty > 0 && +qty <= MAX_PRODUCT_QTY) {
      setLocalQty(qty)
      onChangeQuantity(+qty)
    } else if (qty !== '' && +qty > MAX_PRODUCT_QTY) {
      onChangeQuantity(MAX_PRODUCT_QTY)
      setLocalQty(MAX_PRODUCT_QTY.toString())
    } else {
      setLocalQty(qty)
    }
  }
  const handleBlur = event => {
    const qty = event.target.value
    if (qty !== '' && +qty > 0 && +qty <= MAX_PRODUCT_QTY) {
      onChangeQuantity(+qty)
      setLocalQty(qty)
    } else if (qty !== '' && +qty > MAX_PRODUCT_QTY) {
      onChangeQuantity(MAX_PRODUCT_QTY)
      setLocalQty(MAX_PRODUCT_QTY.toString())
    } else {
      setLocalQty((canZero ? 0 : 1).toString())
    }
  }

  return (
    <div className='quantity-select'>
      <div className='quantity-select__body'>
        <div className='quantity-select__decrease quantity-select__item'>
          <IconButton
            size='medium'
            onClick={() => {
              onChangeQuantity(quantity - 1)
            }}
            disabled={quantity < min}
          >
            <RemoveIcon />
          </IconButton>
        </div>
        <div className='quantity-select__value quantity-select__item appearance-none'>
          <input
            className='max-w-full w-40 text-center border-0 bg-white'
            type='number'
            value={localQty}
            onChange={event => {
              handleChangeQty(event.target.value)
            }}
            onBlur={handleBlur}
          />
        </div>
        <div className='quantity-select__increase quantity-select__item'>
          <IconButton
            size='medium'
            onClick={() => {
              onChangeQuantity(quantity + 1)
            }}
            disabled={quantity >= 50 || quantity === availableQuantity}
          >
            <AddIcon />
          </IconButton>
        </div>
      </div>
    </div>
  )
}

export default QuantityInputField
